'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _store = require('../../../../store/store');

var _store2 = _interopRequireDefault(_store);

var _adsActions = require('../../../../store/actions/ads-actions');

var Actions = _interopRequireWildcard(_adsActions);

var _dfpManager = require('../../../../utils/ads/dfpManager');

var _dfpManager2 = _interopRequireDefault(_dfpManager);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DFP Ad wrapper component
 * @access public
 * @extends {React.Component}
 */
var DFPAd = function (_React$Component) {
  (0, _inherits3.default)(DFPAd, _React$Component);

  /**
   * DFP ads provider generator
   * @param {Object} props React Props for this component
   * @constructor
   */
  function DFPAd(props) {
    (0, _classCallCheck3.default)(this, DFPAd);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DFPAd.__proto__ || (0, _getPrototypeOf2.default)(DFPAd)).call(this, props));

    _store2.default.dispatch(Actions.addSettings(props.settings));
    _store2.default.dispatch(Actions.addEnv(props.env));
    _store2.default.dispatch(Actions.addRequestParams(props.requestParams));
    _store2.default.dispatch(Actions.addContentType(props.contentType));
    return _this;
  }
  /**
   * Call displays methods after all ads got mounted
   */


  (0, _createClass3.default)(DFPAd, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _store2.default.dispatch(Actions.displayAdsAboveTheFold());
      _dfpManager2.default.preFetchAds();
    }

    /**
     * Component wrapper to sync ads status using {@link dfpManager}
     * @returns {JSX}
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);
  return DFPAd;
}(_react2.default.Component);

/**
 * propTypes
 * @property {Array} children Children elements passed to this component
 */


exports.default = DFPAd;


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/components/ads/dfp/DFPAdsProvider/index.js
// module id = 115
// module chunks = 35783957827783 71851226274881